module.exports = __webpack_public_path__ + "assets/img/mobtmn-data.a895c5eb.png";